import React from 'react'
import { useAuthContext } from '../../../Context'
import { getTeamColorByFullName } from '../../../Utils'
import { FavTeamCon } from './styles'

export const FavTeam: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { favTeam } = useAuthContext()

  return (
    <>
      {favTeam && (
        <FavTeamCon teamColor={getTeamColorByFullName(favTeam)}>
          <p className="team">
            {favTeam.charAt(0).toUpperCase() + favTeam.slice(1)} Fan
          </p>
        </FavTeamCon>
      )}
    </>
  )
}
